import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/quotation',
    name: 'quotation',
    component: () => import('../views/quotation.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
